module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l content_right role_management"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "IDE",
      "name": "ide"
    }
  }, [(_vm.active == 'ide') ? _c('list', {
    attrs: {
      "platapplicationcode": 1
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "租户管理",
      "name": "tenant"
    }
  }, [(_vm.active == 'tenant') ? _c('list', {
    attrs: {
      "platapplicationcode": 2
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-493ffd9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493ffd9c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/role/Index.vue
// module id = 237
// module chunks = 0